import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Integration} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {Attachment} from '../types/email-data.types';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {ConstantsService} from './constants.service';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class SettingsIntegrationsService {
    isAppsListShow = false;
    showDetailedView = false;
    showListView = true;
    firstTimeLoading = true;
    selectedItemData: any;
    integrationInIntegrationModal: Integration;

    private websiteBuilderExpandParams = [
        'websiteWelcome',
        'websiteAboutUs',
        'websiteGallery',
        'websiteBuildingFeatures',
        'websiteNeighbourhood',
        'websiteContact',
        'websiteDocument',
        'websiteAnnouncements',
        'websiteGallery.galleryImages',
        'websiteBuildingFeatures.buildingFeaturesImages',
        'websiteContact.phones',
        'websiteContact.socialNetworks'
    ].join(',');

    data = {
        allSettingsAmenities: {
            get: '/v1/amenity?expand=buildingAmenity,createdBy,fees,disabledDates,staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings,reminders',
            data: [],
            total: null
        },
        corporations: {
            get: `/api/v1/website_builder.json?expand=${this.websiteBuilderExpandParams}`,
            data: [],
            total: null
        }
    };
    tabId = 'allSettingsAmenities';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    buldingsInMultiselectFormat: Array<any> = [];
    selectedItemFormattedBuildingsArray: Array<any> = [];
    activities: HistoryItem[];
    modalSpinnerShow = false;
    attachmentsToDisplay: Array<any> = [];
    serviceName: string = 'amenity';
    bookingRequestModalNotificationType = '';
    userRoles: Array<any> = [];
    createdStaffMultiselectArray: Array<any> = [];
    approvedStaffMultiselectArray: Array<any> = [];
    declinedStaffMultiselectArray: Array<any> = [];
    requestStaffMultiselectArray: Array<any> = [];
    bookingCreatedStaffCheckbox = false;
    bookingApprovedStaffCheckbox = false;
    bookingDeclinedStaffCheckbox = false;
    bookingRequestStaffCheckbox = false;
    bookingCreatedResidentCheckbox = false;
    bookingApprovedResidentCheckbox = false;
    bookingDeclinedResidentCheckbox = false;
    bookingRequestResidentCheckbox = false;

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        this.firstTimeLoading = false;
        this.data[this.tabId].total = null;

        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        this.api.get('domainAmenities', `${url}${queryParams}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.data[tabId].data = [];
                this.data[tabId].total = body.total;
                this.emptyRowService.fillEmptyRow();
                entities.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(entities, this.serviceName);
                this.settingsAmenityFactory(entities, this.data[tabId].data);
                if (this.selectedItemData) {
                    this.selectedItemData = this.data[tabId].data.find(si => si.id == this.selectedItemData.id);
                    if (this.selectedItemData) {
                        this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(this.selectedItemData.buildingAmenity);
                        this.selectedItemData.checked = true;
                    } else
                        this.showDetailedView = false;
                }
                this.spinnerShow = false;
                if ($('.table')[0])
                    $('.table')[0].scrollIntoView();
            },
            (error) => {
                this.showServiceUnavailable = true;
                this.spinnerShow = false;
                this.api.errorHandler(error, 'Failed get Amenity Settings');
            }
        );
    }

    settingsAmenityFactory(entities: any, targetArray) {
        entities.forEach((amenity) => {
            const settingsAmenity = new Integration();

            if (amenity.id) settingsAmenity.id = amenity.id;
            if (amenity.internalId) settingsAmenity.internalId = amenity.internalId;
            if (amenity.createdBy) settingsAmenity.createdBy = amenity.createdBy.fullName;
            if (amenity.createdAt) settingsAmenity.createdAt = amenity.createdAt;
            if (amenity.name) settingsAmenity.name = amenity.name;
            if (amenity.timeSequenceType) settingsAmenity.timeSequenceType = amenity.timeSequenceType;
            if (amenity.uses) settingsAmenity.uses = amenity.uses;
            if (amenity.enableStatus) settingsAmenity.enableStatus = amenity.enableStatus;
            if (amenity.allowResidentsToBook) settingsAmenity.allowResidentsToBook = amenity.allowResidentsToBook;
            if (amenity.requiresManagerApproval) settingsAmenity.requiresManagerApproval = amenity.requiresManagerApproval;
            if (amenity.legalAgreement) settingsAmenity.legalAgreement = amenity.legalAgreement;
            if (amenity.legalAgreementStatus) settingsAmenity.legalAgreementStatus = amenity.legalAgreementStatus;
            if (amenity.disclaimerStatus) settingsAmenity.disclaimerStatus = amenity.disclaimerStatus;
            if (amenity.multipleBooking) settingsAmenity.multipleBooking = amenity.multipleBooking;
            if (amenity.multipleBookingMaxCount) settingsAmenity.multipleBookingMaxCount = amenity.multipleBookingMaxCount;
            if (amenity.maxTimeForAdvancedBooking) settingsAmenity.maxTimeForAdvancedBooking = amenity.maxTimeForAdvancedBooking;
            if (amenity.minTimeForAdvancedBooking) settingsAmenity.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
            if (amenity.amenityImage) settingsAmenity.amenityImage = amenity.amenityImage;
            if (amenity.bookings) settingsAmenity.bookings = amenity.bookings;
            if (amenity.buildingAmenity) settingsAmenity.buildingAmenity = amenity.buildingAmenity;
            if (amenity.disabledDates) settingsAmenity.disabledDates = amenity.disabledDates;
            if (amenity.disclaimer) settingsAmenity.disclaimer = amenity.disclaimer;
            if (amenity.fees) settingsAmenity.fees = amenity.fees;
            if (amenity.reminders) settingsAmenity.reminders = amenity.reminders;
            if (amenity.confirmationMessage) settingsAmenity.confirmationMessage = amenity.confirmationMessage;
            if (amenity.staffNotificationSettings) settingsAmenity.staffNotificationSettings = amenity.staffNotificationSettings;
            if (amenity.residentsNotificationSettings) settingsAmenity.residentsNotificationSettings = amenity.residentsNotificationSettings;
            if (amenity.legalAgreementHideFromStaffInterface) settingsAmenity.legalAgreementHideFromStaffInterface = amenity.legalAgreementHideFromStaffInterface;
            if (amenity.disclaimerHideFromStaffInterface) settingsAmenity.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;
            if (amenity.paymentAcceptCash) settingsAmenity.paymentAcceptCash = amenity.paymentAcceptCash;
            if (amenity.paymentAcceptCheques) settingsAmenity.paymentAcceptCheques = amenity.paymentAcceptCheques;
            if (amenity.paymentAcceptCreditCards) settingsAmenity.paymentAcceptCreditCards = amenity.paymentAcceptCreditCards;
            if (amenity.paymentAcceptCustomType) settingsAmenity.paymentAcceptCustomType = amenity.paymentAcceptCustomType;
            if (amenity.paymentCustomTypeName) settingsAmenity.paymentCustomTypeName = amenity.paymentCustomTypeName;
            if (amenity.defaultPaymentMethod) settingsAmenity.defaultPaymentMethod = amenity.defaultPaymentMethod;
            if (amenity.rule) {
                settingsAmenity.rule = amenity.rule;
                if (amenity.rule.bookingMinDay) settingsAmenity.bookingMinDay = amenity.rule.bookingMinDay;
                if (amenity.rule.bookingMaxDay) settingsAmenity.bookingMaxDay = amenity.rule.bookingMaxDay;
                if (amenity.rule.bookingMinHour) settingsAmenity.bookingMinHour = amenity.rule.bookingMinHour;
                if (amenity.rule.bookingMaxHour) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
                if (amenity.rule.technicalBreak) settingsAmenity.technicalBreak = amenity.rule.technicalBreak;
                if (amenity.rule.limitActivityRangeValue) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
                if (amenity.rule.minIntervalBetweenBooking) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
                if (amenity.rule.limitActivityCountBookingOrDays) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
                if (amenity.rule.limitActivityCountBookingOrHours) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
                if (amenity.rule.limitActivityCountBooking) settingsAmenity.bookingMaxHour = amenity.rule.bookingMaxHour;
            }
            if (amenity.managementOverride) settingsAmenity.managementOverride = amenity.managementOverride;
            settingsAmenity.isCanEdit = amenity.isCanEdit;
            settingsAmenity.isCanDelete = amenity.isCanDelete;

            targetArray.push(settingsAmenity);
        });
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc&expand=timeZone`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.buildings = JSON.parse(res._body).entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    toggleDetailedView(data, state: boolean): void {
        if (data && this.selectedItemData && data.id != this.selectedItemData.id)
            this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(data.buildingAmenity);
        else if (data && !this.selectedItemData)
            this.selectedItemFormattedBuildingsArray = this.buildingAmenityConvertForMultiselect(data.buildingAmenity);
        this.selectedItemData = data ? data : null;
        this.showDetailedView = state;
        if (this.selectedItemData) {
            for (const field in this.selectedItemData.formFields)
                this.selectedItemData.formFields[field].editMode = false;
        }
    }

    showAttachment(attachment) {
        const attachmentAsObject = new Attachment(attachment.name, 0, attachment.path);
        if (attachmentAsObject.isImage()) {
            this.es.attachmentInViewAttachmentModal = attachmentAsObject;
            this.es.isViewAttachmentModalShow = true;
        } else if (attachmentAsObject.isNeedViewer()) {
            attachmentAsObject.openViewer();
        } else {
            attachmentAsObject.downloadAttachment();
        }
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
        this.buldingsInMultiselectFormat = this.getBuildingsInProperFormat(this.buildings);
    }

    getBuildingsInProperFormat(arr: Array<any>) {
        return arr.map(building => ({
            id: parseInt(building.id),
            itemName: building.name,
            timezone: building.timeZone ? building.timeZone.value : undefined
        }));
    }

    deleteAmenity(amenity) {
        if (!amenity.id) return;
        swal(ConstantsService.getSwalConfig('Delete Amenity'),
            () => {
                const url = `/v1/amenity/${amenity.id}.json`;
                this.api.remove('domainAmenities', url).subscribe(
                    () => {
                        toastr.success('Amenity has been deleted.');
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Amenity failed')
                );
            }
        );
    }

    buildingAmenityConvertForMultiselect(buildings): any {
        let formated = [];
        if (buildings) {
            buildings.forEach((b) => {
                formated.push({id: b.buildingId});
            });
            formated.forEach((b) => {
                this.buldingsInMultiselectFormat.filter((msb) => {
                    if (msb.id == b.id) {
                        b.itemName = msb.itemName;
                        b.timezone = msb.timezone;
                    }
                });
            });
        }
        return formated;
    }

    public getUserRoles() {
        const url = `/api/v1/role.json?per-page=1000`;
        this.api.get('oauthUrl', url).subscribe(
            res => {
                this.userRoles = [];
                const body = JSON.parse(res._body);
                body.entities.map(role => this.userRoles.push({id: role.id.toString(), itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    getCorporations(): void {
        this.getCorporationsByQueryParams().subscribe();
    }

    getCorporationsByQueryParams() {
        this.showServiceUnavailable = false;
        const queryParams = this.urlService.getQueryParamsString();
        const query = queryParams ? queryParams.slice(0, queryParams.indexOf('&order-by')) : '';
        const url = `/v1/corporation_number.json?${query}&order-by=name|asc&expand=reminders`;
        return this.api.getJson('domainBD', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    (res) => {
                        this.data.corporations.data = res.entities;
                        this.data.corporations.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.showServiceUnavailable = true;
                        this.spinnerShow = false;
                        this.api.errorHandler(error, 'Failed get corporations');
                    }
                )
            );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-integrations.service.ts